var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70775 5.18765C10.6594 5.18765 11.8523 4.54429 12.5626 3.68648C13.206 2.9091 13.6751 1.82343 13.6751 0.737767C13.6751 0.590331 13.6617 0.442895 13.6349 0.322266C12.576 0.362475 11.3027 1.03264 10.5388 1.93066C9.93561 2.61422 9.38607 3.68648 9.38607 4.78555C9.38607 4.94639 9.41288 5.10723 9.42628 5.16084C9.4933 5.17425 9.60052 5.18765 9.70775 5.18765ZM6.35693 21.4056C7.65705 21.4056 8.23339 20.5344 9.85519 20.5344C11.5038 20.5344 11.8657 21.3788 13.3132 21.3788C14.734 21.3788 15.6856 20.0653 16.5836 18.7786C17.5889 17.3042 18.0044 15.8566 18.0312 15.7896C17.9374 15.7628 15.2165 14.6504 15.2165 11.5274C15.2165 8.81993 17.361 7.60024 17.4816 7.50641C16.0609 5.46912 13.903 5.41551 13.3132 5.41551C11.7182 5.41551 10.4181 6.38054 9.60052 6.38054C8.71591 6.38054 7.54983 5.46912 6.16929 5.46912C3.54225 5.46912 0.875 7.64045 0.875 11.7418C0.875 14.2885 1.86684 16.9825 3.08654 18.7249C4.13199 20.1993 5.04342 21.4056 6.35693 21.4056Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialApple);
export default __webpack_public_path__ + "static/media/social-apple.83cad09b3d750ca633346e2f8a2167b9.svg";
export { ForwardRef as ReactComponent };